import { ConnectComponent } from '../../_components/ConnectComponent'
import { PortalPresenter } from './Portal.presenter'
import { PortalView } from './Portal.view'

export const Portal = ConnectComponent(PortalView, PortalPresenter)
